// import TabsList from "../tabs/tabs";
import ExpandableTable from "./expandableTable/expandableTable";
import { useState, useEffect } from "react";
import { cloneDeep, map } from "lodash";
import { Checkbox, Select } from "antd";
import "./interventionCases.scss";
import WellBeEMPIService from "@services/empiService.service";

const InterventionCases = (props: { activeTab: any }) => {
  const [payerLoading, setPayerLoading] = useState<boolean>(false);
  const [selectedPayer, setSelectedPayer] = useState<any>([]);
  const [payerList, setPayerList] = useState<any>([]);
  const allPayer:any = {id: 999, name: "ALL PAYERS"};

  // function to get the list of payers
  useEffect(() => {
    setPayerLoading(true);
    WellBeEMPIService.getPayersList().subscribe({
      next: (v) => {
        setPayerList([allPayer, ...v?.data?.data?.payers]);
        setSelectedPayer([allPayer?.name]);
        setPayerLoading(false);
      },
      error: (e) => {
        console.log(e);
        setPayerLoading(false);
      },
    });
  }, []);

  const onPayorSelect = (payor:any) => {
    if(!payor) {
      setSelectedPayer([allPayer?.name]);
    } else if(selectedPayer.includes(payor)) {
      let temp = cloneDeep(selectedPayer);
      temp = temp.filter((item:any) => item!==payor)
      if(temp.length === 0) {
        temp = [allPayer?.name]
      }
      setSelectedPayer(temp);
    } else {
      let temp = [...selectedPayer, payor];
      if(payor === allPayer?.name) {
        temp = [allPayer?.name]
      }
      else if(temp.includes(allPayer?.name)){
        temp = temp.filter((item:any)=>item!==allPayer?.name)
      }
      setSelectedPayer(temp);
    }
  }

  return (
    <div className="ui-empi-interventions">
      {payerLoading ? (
        <div className="ui-empi-interventions__payer-preloader shimmerBG"></div>
      ) : (
        <Select
          value={`${selectedPayer.length > 1 ? `${selectedPayer?.[0]}, +${selectedPayer.length - 1}` : selectedPayer?.[0]}`}
          size="large"
          placeholder={"Select Payer"}
          onChange={(value) => {
            onPayorSelect(value);
          }}
          className="ui-empi-interventions__payer"
          allowClear
          onClear={() => setSelectedPayer([allPayer?.name])}
        >
          {map(payerList, (item) => {
            return (
              <Select.Option key={item.name} value={item.name}>
                <Checkbox  onChange={(e)=>{onPayorSelect(item.name); e.preventDefault(); e.stopPropagation()}} checked={selectedPayer.includes(item.name)}>{item.name}</Checkbox>
              </Select.Option>
            );
          })}
        </Select>
      )}
      {selectedPayer && <ExpandableTable payer={selectedPayer} activeTab={props.activeTab} />}
    </div>
  );
};

export default InterventionCases;
